var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlockClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.1562C5.125 10.1562 4.84375 9.875 4.84375 9.5V8C4.84375 7.64844 5.125 7.34375 5.5 7.34375C5.85156 7.34375 6.15625 7.64844 6.15625 8V9.5C6.15625 9.875 5.85156 10.1562 5.5 10.1562ZM10.75 6.125V11.375C10.75 12.0078 10.2344 12.5 9.625 12.5H1.375C0.742188 12.5 0.25 12.0078 0.25 11.375V6.125C0.25 5.51562 0.742188 5 1.375 5H2.125V3.875C2.125 2.02344 3.625 0.5 5.5 0.5C7.375 0.523438 8.875 2.04688 8.875 3.92188V5H9.625C10.2344 5 10.75 5.51562 10.75 6.125ZM3.25 5H7.75V3.875C7.75 2.65625 6.71875 1.625 5.5 1.625C4.25781 1.625 3.25 2.65625 3.25 3.875V5ZM9.625 6.125H1.375V11.375H9.625V6.125Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockClosed);
export default __webpack_public_path__ + "static/media/padlock-closed.4ad7b861.svg";
export { ForwardRef as ReactComponent };